module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("Page not found")])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-21d86d68","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/404.vue
// module id = 161
// module chunks = 4